module.exports = __webpack_public_path__ + "static/media/summit-facial-register-logo.bfc985b5.svg";